import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';


export default function InnovatorsHome() {
  return (
    <Box sx={{ minWidth: 275 }}>
      <Card onClick={() => window.location='/innovator-phone'} style={myStyle.pointerStyle} variant='outlined'  >
      <CardContent>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center' }}>
      <div style={{backgroundColor:'blue', padding:'10px 10px 5px 10px', borderRadius:'50px 50px 50px 50px'}}><AddIcon sx={{ color: 'white' }} /></div>
      <div> Add New Innovator </div>
      </div>
    </CardContent>
      </Card>
    <Card onClick={() => window.location='/innovator-phone'} style={myStyle.pointerStyle}  variant='outlined'  >
      <CardContent >
        <div style={{display:'flex',justifyContent:'center',alignItems:'center' }}>
        <div style={{backgroundColor:'green', padding:'10px 10px 5px 10px', borderRadius:'50px 50px 50px 50px'}}><PublishedWithChangesIcon sx={{ color: 'white' }} /></div>
        <div> Update Innovator </div>
        </div>
      </CardContent>
    </Card>
    
    </Box>
  );
}

const myStyle = {
  pointerStyle:{
    cursor: 'pointer'
  }
}